import { useActivity } from 'hooks/useBusiness.js';
import React, { useState, useEffect, useMemo } from "react";
import { Wrapper, Container, Img, Progress, Tab as ProgBtn, Arrow, Btn } from './style.js';
import { useNavigate } from 'react-router-dom';
import { advertsForWebPlacement } from 'utils/advertFilters';
import { trackAdvertClick, trackProductClick } from 'services/webAnalytics';

const Carousel = ({ position = 'top' }) => {
    const { state } = useActivity();
    const [index, setIndex] = useState(0);
    const navigate = useNavigate();

    const webAdverts = useMemo(
        () => advertsForWebPlacement(state?.adverts, position),
        [state?.adverts, position],
    );

    const len = webAdverts.length;

    useEffect(() => {
        if (!len) return undefined;
        const id = setTimeout(() => {
            setIndex((prev) => (len ? (prev + 1) % len : 0));
        }, 6000);
        return () => clearTimeout(id);
    }, [index, len]);

    useEffect(() => {
        setIndex((i) => (len ? Math.min(i, len - 1) : 0));
    }, [len]);

    if (len === 0) {
        return null;
    }

    return (
        <Wrapper>
            <Container>
                {webAdverts.map((item, id) => (
                    <Img
                        onClick={() => {
                            if (item?.id != null) {
                                trackAdvertClick(item.id);
                            }
                            if (item?.product_id) {
                                trackProductClick(item.product_id);
                                navigate(`/product/product/${item.product_id}`);
                                return;
                            }
                            if (item?.link) {
                                window.open(item.link);
                            }
                        }}
                        src={item?.medias?.[0]?.filename}
                        index={index}
                        key={item?.id ?? item?.uuid ?? id}
                        alt=""
                    />
                ))}
                <Arrow>
                    <Btn
                        onClick={() =>
                            setIndex((prev) =>
                                len ? (prev === 0 ? len - 1 : prev - 1) : 0,
                            )
                        }
                        dir="left"
                    />
                    <Btn
                        onClick={() =>
                            setIndex((prev) => (len ? (prev + 1) % len : 0))
                        }
                        dir="right"
                    />
                </Arrow>
            </Container>
            {position === 'top' ? (
                <Progress>
                    {webAdverts.map((_, id) => (
                        <ProgBtn
                            current={index === id}
                            onClick={() => setIndex(id)}
                            key={id}
                        />
                    ))}
                </Progress>
            ) : null}
        </Wrapper>
    );
};

export default Carousel;
